module.exports = __webpack_public_path__ + "img/me.62251878.svg";